import React from 'react';
import './App.css';
import NewsContainer from "./components/NewsContainer.js";

function App() {

  let today = new Date();
  let dd = String(today.getDate()).padStart(2, '0');
  let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  let yyyy = today.getFullYear();
  let todaysDate = mm + '/' + dd + '/' + yyyy;

  return (
    <div className='wrapper'>
      <div className="header">
        <h1>Bitcoin News </h1>
        <p>News fetched from News API</p>
        <p>{ todaysDate.toString() }</p>

      </div>
      <NewsContainer />
    </div>
  );
}

export default App;
